import { addDays, startOfDay, subDays } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { eventProduct } from '../constants/common.constants';
import { EventProduct } from '../enums/event.enums';
import { ProductType } from '../types/products.types';
import { targetsToBE } from './Target.transformer';
import { EventState } from 'basics/types/maya.types';
import { Event } from 'generated/event.types';

export const eventToEventState = (event: Event, allProducts: ProductType[]): EventState => {
  const { startDate = '', endDate = '' } = event.data?.session ? event.data.session : {};
  const dateStart = startOfDay(utcToZonedTime(new Date(startDate), 'UTC'));
  const dateEnd = startOfDay(utcToZonedTime(new Date(endDate), 'UTC'));
  const prcCodeEventDetails = event.data?.biogenLincConfig?.prcCodeEventDetails;
  const filteredProduct = allProducts.find(
    (product: ProductType) => product.productName.toLowerCase() === event.data?.product?.toLowerCase(),
  );

  return {
    title: event.title,
    country: event?.originMarket?.toUpperCase() || '',
    product: filteredProduct?.productExternalID || eventProduct[event?.data?.product as EventProduct] || '',
    startDate: dateStart,
    endDate: dateEnd,
    assetName: prcCodeEventDetails && prcCodeEventDetails?.length <= 255 ? prcCodeEventDetails : '',
    eventId: event.externalId || '',
    eventURL: event.data?.biogenLincConfig?.detailsPageUrl || '',
    targets: event.data?.participants?.map(targetsToBE) || [],
    dataRange: [subDays(dateStart, 14), addDays(dateEnd, 14)],
  };
};
